import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import GooglePayButton from './GooglePayButton';  // Import the Google Pay Button component

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const GooglePay = () => {
  return (
    <Elements stripe={stripePromise}>
      <GooglePayButton />
    </Elements>
  );
};

export default GooglePay;
